
export const setItemWithExpiry = (key, value, ttl) => {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl, // Set expiry time
    };
    localStorage.setItem(key, JSON.stringify(item)); // Store in localStorage
  };
  
  export const getItemWithExpiry = (key) => {
    const item = JSON.parse(localStorage.getItem(key));
    const now = new Date();
  
    if (!item) {
      return null;
    }
  
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key); // Remove expired item
      return null;
    }
  
    return item.value;
  };
  